"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Dropdown = require("@emcasa/ui/lib/components/Dropdown");

var _class, _temp;

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  z-index: -1;\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  overflow-y: auto;\n  ", ";\n  ", ";\n  display: ", ";\n  box-sizing: border-box;\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = (0, _styledComponents["default"])((_temp = _class =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(DropdownContainer, _PureComponent);

  function DropdownContainer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, DropdownContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(DropdownContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDocumentClick", function (e) {
      var _this$props = _this.props,
          focused = _this$props.focused,
          onDropdownBlur = _this$props.onDropdownBlur;
      var target = _this.targetDOMNode;

      if (focused && target && onDropdownBlur && target && !target.contains(e.target)) {
        onDropdownBlur();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onDocumentFocus", function (e) {
      var _this$props2 = _this.props,
          focused = _this$props2.focused,
          onDropdownBlur = _this$props2.onDropdownBlur,
          onDropdownFocus = _this$props2.onDropdownFocus;
      var target = _this.targetDOMNode;
      if (focused && target && !target.contains(e.target)) onDropdownBlur();else if (!focused && target && target.contains(e.target)) onDropdownFocus();
    });
    return _this;
  }

  (0, _createClass2["default"])(DropdownContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('touchend', this.onDocumentClick);
      document.addEventListener('focus', this.onDocumentFocus, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('touchend', this.onDocumentClick);
      document.removeEventListener('focus', this.onDocumentFocus, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          id = _this$props3.id,
          className = _this$props3.className,
          style = _this$props3.style;
      return _react["default"].createElement("div", {
        tabIndex: "-1",
        id: id,
        className: className,
        style: style
      }, children);
    }
  }, {
    key: "targetDOMNode",
    get: function get() {
      return this.props.target ? _reactDom["default"].findDOMNode(this.props.target) : undefined;
    }
  }]);
  return DropdownContainer;
}(_react.PureComponent), (0, _defineProperty2["default"])(_class, "propTypes", _Dropdown.container.propTypes), _temp))(_templateObject(), _Dropdown.container, _Dropdown.container.contentContainer, function (_ref) {
  var focused = _ref.focused;
  return focused ? 'flex' : 'none';
});

exports["default"] = _default;